"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StationStatus = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@geome/react-next/lib/hooks/i18n");
const StationStatus = ({ location }) => {
    const { translate } = (0, i18n_1.useI18n)();
    const siteStatus = location.site_status;
    if (siteStatus === "Active" || !siteStatus)
        return null;
    const siteStatusKey = siteStatus.replace(" ", "_").toLowerCase();
    return ((0, jsx_runtime_1.jsx)("div", { "aria-role": "alert", className: "location-page__status", children: translate(`station_page.site_status.${siteStatusKey}`) }));
};
exports.StationStatus = StationStatus;
